export class ConstantValues {
  public static AUTHORIZATION_TOKEN = 'AUTHORIZATION_TOKEN';
  public static HASH_MISMATCH_ERROR = 'HASH_MISMATCH_ERROR';

  //Login
  public static LOGIN = 'LOGIN';
  public static TWO_FACTOR_VERIFY = 'TWO_FACTOR_VERIFY';

  static readonly REJECTED_TYPE = 'PAYME_PENSION_REJECTED_TYPE';

  //Department
  public static CREATE_DEPARTMENT = 'CREATE_DEPARTMENT';
  public static UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
  public static GET_DEPARTMENT_LIST = 'GET_DEPARTMENT_LIST';
  public static GET_DEPARTMENT_DETAIL = 'GET_DEPARTMENT_DETAIL';
  public static DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';

  //Ministry
  public static CREATE_MINISTRY = 'CREATE_MINISTRY';
  public static GET_MINISTRY_LIST = 'GET_MINISTRY_LIST';
  public static GET_MINISTRY_OPTIONS = 'GET_MINISTRY_OPTIONS';
  public static GET_MINISTRY_DETAIL = 'GET_MINISTRY_DETAIL';
  public static UPDATE_MINISTRY = 'UPDATE_MINISTRY';
  public static DELETE_MINISTRY = 'DELETE_MINISTRY';

  //Position
  public static CREATE_POSITION = 'CREATE_POSITION';
  public static GET_POSITION_LIST = 'GET_POSITION_LIST';
  public static GET_POSITION_DETAIL = 'GET_POSITION_DETAIL';
  public static UPDATE_POSITION = 'UPDATE_POSITION';
  public static DELETE_POSITION = 'DELETE_POSITION';

  //Agetn
  public static CREATE_AGENT = 'CREATE_AGENT';
  public static CHECK_AGENT_MOBILENUMBER = 'CHECK_AGENT_MOBILENUMBER';
  public static GET_AGENT_LIST = 'GET_AGENT_LIST';
  public static GET_AGENT_DETAIL = 'GET_AGENT_DETAIL';
  public static UPDATE_AGENT = 'UPDATE_AGENT';
  public static UNBLOCK_AGENT = 'UNBLOCK_AGENT';
  public static DELETE_AGENT = 'DELETE_AGENT';
  public static UPDATE_AGENT_STATUS = 'UPDATE_AGENT_STATUS';
  public static GET_AGENTPERMISSION_LIST = 'GET_AGENTPERMISSION_LIST';

  //AdminRole
  public static CREATE_ADMINROLE = 'CREATE_ADMINROLE';
  public static UPDATE_ADMINROLE = 'UPDATE_ADMINROLE';
  public static GET_ADMINROLE_LIST = 'GET_ADMINROLE_LIST';
  public static GET_ADMINROLE_DETAIL = 'GET_ADMINROLE_DETAIL';
  public static DELETE_ADMINROLE = 'DELETE_ADMINROLE';

  //AdminUser
  public static CREATE_ADMINUSER = 'CREATE_ADMINUSER';
  public static UPDATE_ADMINUSER = 'UPDATE_ADMINUSER';
  public static GET_ADMINUSER_LIST = 'GET_ADMINUSER_LIST';
  public static GET_ADMINUSER_DETAIL = 'GET_ADMINUSER_DETAIL';
  public static LOGIN_ADMINUSER = 'LOGIN_ADMINUSER';
  public static VERIFY_OTP_CODE = 'VERIFY_OTP_CODE';
  public static REFRESH_TOKEN = 'REFRESH_TOKEN';
  public static DELETE_ADMINUSER = 'DELETE_ADMINUSER';
  public static RESENT_OTP = 'RESENT_OTP';

  //Divisino
  public static GET_DIVISIONS_LIST = 'GET_DIVISIONS_LIST';

  //Township
  public static GET_TOWNSHIP_LIST = 'GET_TOWNSHIP_LIST';

  //Admin User Permission
  public static GET_ADMINUSERPERMISSION_LIST = 'GET_ADMINUSERPERMISSION_LIST';

  //AdminRoleClaimn
  public static CREATE_ADMINROLECLAIM = 'CREATE_ADMINROLECLAIM';
  public static UPDATE_ADMINROLECLAIM = 'UPDATE_ADMINROLECLAIM';

  //App
  public static GET_TOWNSHIPSBYDIVISION = 'GET_TOWNSHIPSBYDIVISION';
  public static GET_ADDRESS_TOWNSHIP_LIST = 'GET_ADDRESS_TOWNSHIP_LIST';

  //Region
  public static GET_REGION_LIST = 'GET_REGION_LIST';
  public static GET_REGION_DETAIL = 'GET_REGION_DETAIL';
  public static CREATE_REGION = 'CREATE_REGION';
  public static UPDATE_REGION = 'UPDATE_REGION';
  public static GET_REGION_OPTIONS = 'GET_REGION_OPTIONS';
  public static DELETE_REGION = 'DELETE_REGION';

  //Agent Role
  public static CREATE_AGENTROLE = 'CREATE_AGENTROLE';
  public static UPDATE_AGENTROLE = 'UPDATE_AGENTROLE';
  public static GET_AGENTROLE_LIST = 'GET_AGENTROLE_LIST';
  public static GET_AGENTROLE_DETAIL = 'GET_AGENTROLE_DETAIL';
  public static DELETE_AGENTROLE = 'DELETE_AGENTROLE';
  public static GET_AGENTROLE_OPTIONS = 'GET_AGENTROLE_OPTIONS';
  public static GET_AGENTFORASSIGNED_LIST = 'GET_AGENTFORASSIGNED_LIST';

  //CashCollectionPoint
  public static CREATE_CASH_COLLECTION_POINT = 'CREATE_CASH_COLLECTION_POINT';
  public static UPDATE_CASH_COLLECTION_POINT = 'UPDATE_CASH_COLLECTION_POINT';
  public static DELETE_CASH_COLLECTION_POINT = 'DELETE_CASH_COLLECTION_POINT';
  public static GET_CASH_COLLECTION_POINT_LIST =
    'GET_CASH_COLLECTION_POINT_LIST';
  public static GET_CASH_COLLECTION_POINT_DETAIL =
    'GET_CASH_COLLECTION_POINT_DETAIL';
  public static GET_CASH_COLLECTION_POINT_OPTIONS =
    'GET_CASH_COLLECTION_POINT_OPTIONS';

  //Request Management
  public static GET_PENSIONER_BY_FILTER = 'GET_PENSIONER_BY_FILTER';
  public static CREATE_INFORMATINOCHANAGES = 'CREATE_INFORMATINOCHANAGES';
  public static UPDATE_INFORMATINOCHANAGES = 'UPDATE_INFORMATINOCHANAGES';
  public static GET_INFORMATINOCHANAGE_LIST = 'GET_INFORMATINOCHANAGE_LIST';
  public static GET_INFORMATINOCHANAGES_DETAIL =
    'GET_INFORMATINOCHANAGES_DETAIL';

  public static CREATE_HOMESERVICE = 'CREATE_HOMESERVICE';
  public static GET_HOMESERVICE_LIST = 'GET_HOMESERVICE_LIST';
  public static UPDATE_HOMESERVICE = 'UPDATE_HOMESERVICE';

  // Pensioner
  public static CREATE_PENSIONER = 'CREATE_PENSIONER';
  public static UPDATE_PENSIONER = 'UPDATE_PENSIONER';
  public static DELETE_PENSIONER = 'DELETE_PENSIONER';
  public static GET_PENSIONER_LIST = 'GET_PENSIONER_LIST';
  public static GET_PENSIONIMPORTED_LIST = 'GET_PENSIONIMPORTED_LIST';
  public static GET_PENSION_DETAIL = 'GET_PENSION_DETAIL';
  public static GET_OTP = 'GET_OTP';
  public static GET_PENSION_LIST = 'GET_PENSION_LIST';
  public static GET_PENSIONER_LIST_BYFILTER = 'GET_PENSIONER_LIST_BYFILTER';
  public static GET_PENSIONERREGISTRATION_LIST =
    'GET_PENSIONERREGISTRATION_LIST';
  public static GET_BATCHFILE_LIST = 'GET_BATCHFILE_LIST';
  public static GET_BATCHFILE_DETAIL = 'GET_BATCHFILE_DETAIL';
  public static GET_PENSIONER_DETAIL = 'GET_PENSIONER_DETAIL';
  public static GET_PENSIONIMPORTED_DETAIL = 'GET_PENSIONIMPORTED_DETAIL';
  public static GET_PENSIONERREGISTRATION_DETAIL =
    'GET_PENSIONERREGISTRATION_DETAIL';
  public static GET_PAYMEUSER_CHANGE_DETAIL = 'GET_PAYMEUSER_CHANGE_DETAIL';
  public static UPLOAD_PENSIONER = 'UPLOAD_PENSIONER';
  public static GET_PENSIONER_BY_PPANO = 'GET_PENSIONER_BY_PPANO';
  public static GET_PENDING_PAYMEUSER_REGISTRATION =
    'GET_PENDING_PAYMEUSER_REGISTRATION';
  public static GET_IMAGEFILE = 'GET_IMAGEFILE';
  public static GET_PENSIONTYPE_OPTIONS = 'GET_PENSIONTYPE_OPTIONS';
  public static GET_PENSION_CHANGE_DETAIL = 'GET_PENSION_CHANGE_DETAIL';

  public static GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';

  // PaymeUser
  public static UPDATE_PAYMEUSER = 'UPDATE_PAYMEUSER';
  public static GET_PAYMEUSER_DETAIL = 'GET_PAYMEUSER_DETAIL';
  public static UPDATE_PAYMEUSER_STATUS = 'UPDATE_PAYMEUSER_STATUS';
  public static GET_RELATIONTONRC_OPTIONS = 'GET_RELATIONTONRC_OPTIONS';
  public static GET_MINISTRY_LIST_OPTIONS = 'GET_MINISTRY_OPTIONS';
  public static GET_DEPARTMENT_LIST_OPTIONS = 'GET_DEPARTMENT_LIST';

  // Pension
  public static UPDATE_PENSION = 'UPDATE_PENSION';
  public static UPDATE_PENSION_STATUS = 'UPDATE_PENSION_STATUS';

  public static TokenKey = 'pms-token';
  public static TerminalId = 'terminal-id';
  public static BranchId = 'branch-id';
  public static UserRole = 'user-role';
  public static RefreshTokenKey = 'pms-refresh-token';
  public static PhoneNumber = 'pms-phone-number';
  public static LoginUserEmail = 'pms-loginuser-email'
  public static PaymeVerificationKey = 'origin-paymeuserdetail-come';
  public static PaymeAgentVerificationKey = 'origin-agent-verification';
  public static OriginComeParamKey = 'origin-come-param';
  public static CreateRequestFormIdKey = 'pms_createrequest_id';

  public static FOSAgentccessPermission = 'FOS Agent Access Permission';

  static readonly StaticValue = class {
    static readonly AssignTask: string = 'AssignTasks';
    static readonly LV1Approved: string = 'LV1Approved';
    static readonly L1Rejected: string = 'LV1Rejected';
    static readonly LV2Approved: string = 'LV2Approved';
    static readonly L2Rejected: string = 'LV2Rejected';
    static readonly PDL1Approved: string = 'PDL1Approved';
    static readonly PDL2Approved: string = 'PDL2Approved';
    static readonly PDL1Rejected: string = 'PDL1Rejected';
    static readonly PDL2Rejected: string = 'PDL2Rejected';
    static readonly PDLV1Approved: string = 'PDLV1Approved';
    static readonly PDLV2Approved: string = 'PDLV2Approved';
    static readonly PDL2Reject: string = 'PDL2Reject';
    static readonly PDL1Reject: string = 'PDL1Reject';
    static readonly Deceased: string = 'Deceased';
    static readonly pdtransaction: string = 'pdtransaction';
    // static readonly PDApproved:string = "PDApproved";
    // static readonly PDRejected:string = "PDRejected";
    static readonly Rejected: string = 'Rejected';
    static readonly Reject: string = 'Reject';
    static readonly PDRejected: string = 'PDRejected';
    static readonly PaymeRejected: string = 'PayMeRejected';
    static readonly ExpiredLiveVerified: string = 'ExpiredLiveVerified';
    static readonly RejectedPension: string = 'RejectedPension';
    static readonly Approved: string = 'Approved';
    static readonly Success: string = 'Success';
    static readonly Reverse: string = 'REVERSE';
    static readonly RejectedFundout: string = 'REJECTED';
    static readonly Pending: string = 'Pending';
    static readonly PendingApproval: string = 'PENDING_APPROVAL';
    static readonly Imported: string = 'Imported';
    static readonly Active: string = 'Active';
    static readonly InActive: string = 'InActive';
    static readonly LV1Verification: string = 'LV1 Verification';
    static readonly LV2Verification: string = 'LV2 Verification';
    static readonly LV3Verification: string = 'LV3 Verification';
    static readonly AgentLists: string = 'Agent Lists';
    static readonly ExpiredLiveVerify: string = 'ExpiredLiveVerify';
    static readonly Suspense: string = 'Suspense';
    static readonly VerficationUserUpdate: string = 'Verification.User.Update';

    static readonly Found: string = 'Found';
    static readonly NotFound: string = 'NotFound';
    static readonly All: string = 'All';

    static readonly True: string = 'true';
    static readonly False: string = 'false';
    static readonly Defense: string = 'Defense';
    static readonly PayemeUser: string = 'PayemeUser';
    static readonly Pension: string = 'Pension';
    static readonly PensionOfFmaily: string = 'PensionOfFmaily';
    static readonly PensionDetail: string = 'PensionDetail';
    static readonly DeceasedPensionDetail: string = 'DeceasedPensionDetail';
    static readonly AgeOfBeneficiaryPensioner: string =
      'AgeOfBeneficiaryPensioner';

    static readonly Guardian: string = 'guardian';
    static readonly PensionRelation: string = 'pension';

    static readonly Civil: string = 'Civil';

    static readonly PMS_SYTSTEM_LANG: string = 'PMS_SYTSTEM_LANG';
    static readonly NewNRC: string = 'NewNRC';
    static readonly OldNRC: string = 'OldNRC';
  };
// Pinsin liveness fail
    public static PhoneNumberKey = 'PhoneNumber'; 


}
